import { toast } from 'react-toastify';
import { useMemo, useCallback } from 'react';

import { getErrorMessage } from 'utils/error';
import { Alert, AlertProps } from 'components';

export const useAlert = () => {
  const showAlert = (title: string, options: AlertProps['options']) =>
    toast(Alert, { data: { title, options } });

  const handleError = useCallback(
    (error: any) => showAlert(getErrorMessage(error), { severity: 'error' }),
    []
  );

  const showSuccessAlert = useCallback(
    (message: string, options?: AlertProps['options']) =>
      showAlert(message, { severity: 'success', ...options }),
    []
  );

  const showErrorAlert = useCallback(
    (message: string, options?: AlertProps['options']) =>
      showAlert(message, { severity: 'error', ...options }),
    []
  );

  return useMemo(
    () => ({
      handleError,
      showErrorAlert,
      showSuccessAlert,
    }),
    [handleError, showErrorAlert, showSuccessAlert]
  );
};
